import type { CSSProperties, ReactNode } from 'react';

interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  padding?: number | string;
  children?: ReactNode;
  style?: CSSProperties;
  bodyStyle?: CSSProperties;
  noBody?: boolean;
}

export function Card({
  title,
  subtitle,
  actions,
  padding = 16,
  children,
  style,
  bodyStyle,
  noBody,
}: CardProps) {
  return (
    <div
      style={{
        background: 'var(--bx-card-bg)',
        border: '1px solid var(--bx-border-muted)',
        borderRadius: 'var(--bx-radius-lg)',
        boxShadow: 'var(--bx-shadow-card)',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        ...style,
      }}
    >
      {(title || actions) && (
        <div
          style={{
            padding: '14px 16px',
            borderBottom: noBody ? 'none' : '1px solid var(--bx-border-muted)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 0 }}>
            {title && (
              <div
                style={{ fontSize: 14, fontWeight: 600, color: 'var(--bx-text-heading)' }}
              >
                {title}
              </div>
            )}
            {subtitle && (
              <div style={{ fontSize: 11.5, color: 'var(--bx-text-muted)', marginTop: 2 }}>
                {subtitle}
              </div>
            )}
          </div>
          {actions && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{actions}</div>
          )}
        </div>
      )}
      {!noBody && <div style={{ padding, ...bodyStyle }}>{children}</div>}
    </div>
  );
}
